const API_URL = process.env.REACT_APP_API_URL;

let apiUrls = {
    elements: `${API_URL}/vdp-uthealth-design`,
};

export default apiUrls;
